import cn from 'classnames';
import { CalibrationLevel } from 'libs/end-to-end/src/calibration-level';
import { getCalibrationFramingDescriptorId } from 'libs/end-to-end/src/ui';
import { getCalibrationLevelUIDetails } from 'libs/end-to-end/src/ui';
import React from 'react';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { CalibrationFraming } from 'libs/end-to-end/src/calibration-framing';

interface CalibrationLevelPillProps {
  calibrationLevel: CalibrationLevel;
  isPrediction?: boolean;
  calibrationFraming: CalibrationFraming;
}

export function CalibrationLevelPill(props: CalibrationLevelPillProps) {
  const { calibrationLevel, calibrationFraming } = props;
  const language = useLanguage();
  const uiDetails = getCalibrationLevelUIDetails(props.calibrationFraming)[
    calibrationLevel
  ];
  const calibrationLevelStatement =
    language[
      getCalibrationFramingDescriptorId({
        calibrationFraming,
        calibrationLevel,
      })
    ]();
  const predictedLiteral = language.predicted();

  const pillStatement = props.isPrediction
    ? `${calibrationLevelStatement} ${predictedLiteral}`
    : `${calibrationLevelStatement}`;

  return (
    <div className="my-2">
      <p
        className={cn(
          'inline rounded-full text-white my-4 py-1 px-2 text-center',
          uiDetails.bgColor,
        )}
      >
        {pillStatement}
      </p>
    </div>
  );
}
